import { render } from "./IntroductionParagraph.vue?vue&type=template&id=28bea9fc&scoped=true"
import script from "./IntroductionParagraph.vue?vue&type=script&lang=js"
export * from "./IntroductionParagraph.vue?vue&type=script&lang=js"

import "./IntroductionParagraph.vue?vue&type=style&index=0&id=28bea9fc&scoped=true&lang=css"

import exportComponent from "/home/dre/personalsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bea9fc"]])

export default __exports__